<template>
    <footer class="footer">
        <div class="footer-top">
            <div class="container">
                <div class="footer-top-content">
                    <div class="footer-top-content-item">
                        <div class="footer-top-content-item-title">关于旅享</div>
                        <div class="footer-top-content-item-main">
                            <router-link to="/about">
                                公司简介
                            </router-link>
                            <router-link to="/introduction">
                                企业文化
                            </router-link>
                            <router-link to="/partner">
                                发展历程
                            </router-link>
                            <!-- <router-link to="">
                                招贤纳士
                            </router-link> -->
                        </div>
                    </div>
                    <div class="footer-top-content-item">
                        <div class="footer-top-content-item-title">产品中心</div>
                        <div class="footer-top-content-item-main">
                            <a target="_blank" href="https://itunes.apple.com/cn/app/id1384495302">
                                iOS
                            </a>
                            <a target="_blank" href="http://sj.qq.com/myapp/detail.htm?apkName=com.lvxiang.risingvideo">
                                安卓
                            </a>
                        </div>
                    </div>
                    <div class="footer-top-content-item">
                        <div class="footer-top-content-item-title">品牌优势</div>
                        <div class="footer-top-content-item-main">
                            <!-- <router-link to="/about">
                                品牌故事
                            </router-link> -->
                            <router-link to="/report">
                                媒体报导
                            </router-link>
                            <router-link to="/honor">
                                旅享荣誉
                            </router-link>
                            <router-link to="/progress">
                                发展历程
                            </router-link>
                            <!-- <router-link to="">
                                品牌优势
                            </router-link> -->
                        </div>
                    </div>
                    <!-- <div class="footer-top-content-item">
                        <div class="footer-top-content-item-title">案例展示</div>
                        <div class="footer-top-content-item-main">
                            <router-link to="">
                                客户案例
                            </router-link>
                            <router-link to="">
                                新品推荐
                            </router-link>
                            <router-link to="/partner">
                                服务流程
                            </router-link>
                        </div>
                    </div> -->
                </div>
                <div class="footer-top-qrcode">
                    <img src="@/assets/img/qrcode.png" alt="">
                    <!-- <span>扫一扫，关注我们</span> -->
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <!-- <p>咨询热线：18321223168</p>
                <p>投诉热线：18321223168</p>
                <p>微信公众号：rising3168</p>
                <p>咨询邮箱：84641870@qq.com</p> -->
                <p>©2019 版权所有 旅享网络科技（上海）有限公司 <a href="http://www.beian.miit.gov.cn/" target="blank" style="color:#fff;">沪ICP16032996号-1 </a><br/>运营中心：阿里巴巴集团创新中心（无锡基地）A03 电话：18321223168<br/><a  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502010742" target="blank" style="color:#fff;">沪公网安备31011502010742号</a></p>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name:'footerComponent'
}
</script>
<style lang="scss" scoped>
.container{
    width: 1000px;
}
.footer{
    min-width: 1200px;
    &-top{
        background: #fff;
        padding: 50px 0;
        .container{
            @include flexMode(flex-start,space-between,row);
        }
        &-content{
            width: 700px;
            @include flexMode(flex-start,space-between,row);
            &-item{
                &-title{
                    font-size: 18px;
                    font-weight: 600;
                    margin-bottom: 30px;
                }
                &-main{
                    a{
                        display: block;
                        margin-bottom:15px; 
                        font-size: 14px;
                        color: #999;
                        &:hover{
                            color: $base-color;
                        }
                        &:last-of-type{
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
        &-qrcode{
            img{
                width: 150px;
            }
            span{
                display: block;
            }
        }
    }
    &-bottom{
        background: $base-color;
        padding: 30px 0;
        .container{
            width: 600px;
        }
        p{
            color: #fff;
            text-align: center;
            font-size: 14px;
            line-height: 1.5;
            &:last-of-type{
                font-size: 12px;
            }
        }
    }
}
//中型屏幕
@media only screen and (max-width: $screen-lg-min){
    .footer{
        min-width: 100%;
        
    }
    .container{
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
    }

}
//移动端和ipad
@media only screen and (max-width: $screen-sm-min){
    .footer{
        min-width: 100%;
    }
    .container{
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
    }
    .footer-top .container{
        @include flexMode(center,center,column);
    }
    .footer-top-content{
        width: 100%;
        flex-wrap: wrap;
    }
    .footer-top-content-item{
        width: 90px;
        margin-bottom: 20px;
    }
    .footer-bottom .container{
        width: 100%;
    }
}  
</style>